import {HttpRequest, HttpMethod} from "./http";

class KOLProvider extends HttpRequest {
    // Staff
    StaffList(params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/staff`, params);
    }
    StaffDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/staff/${id}`);
    }
    StaffCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/kol/staff`, params);
    }
    StaffUpdate(id, params) {
        return this.request(HttpMethod.Put, `/api/v3/kol/staff/${id}`, params);
    }
    StaffDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/kol/staff/${id}`);
    }

    // Creators
    CreatorList(params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/creators`, params);
    }
    CreatorDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/creators/${id}`);
    }
    CreatorCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/kol/creators`, params);
    }
    CreatorUpdate(id, params) {
        return this.request(HttpMethod.Put, `/api/v3/kol/creators/${id}`, params);
    }
    CreatorDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/kol/creators/${id}`);
    }
    CreatorUploadFile(id, type, file) {
        const fd = new FormData();
        fd.append("file", file);
        return this.request(HttpMethod.Post, `/api/v3/kol/creators/${id}/files/${type}`, fd);
    }
    CreatorGetFileURL(id, type) {
        return this.request(HttpMethod.Get, `/api/v3/kol/creators/${id}/files/${type}`);
    }

    // Assignments
    AssignmentList(params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/assignments`, params);
    }
    AssignmentDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/assignments/${id}`);
    }
    AssignmentCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/kol/assignments`, params);
    }
    AssignmentUpdate(id, params) {
        return this.request(HttpMethod.Put, `/api/v3/kol/assignments/${id}`, params);
    }
    AssignmentDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/kol/assignments/${id}`);
    }
    AssignmentUpdateStatus(id, params) {
        return this.request(HttpMethod.Patch, `/api/v3/kol/assignments/${id}/status`, params);
    }
    AssignmentUpdatePayment(id, params) {
        return this.request(HttpMethod.Patch, `/api/v3/kol/assignments/${id}/payment`, params);
    }
    AssignmentTimeline(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/assignments/${id}/timeline`);
    }
    AssignmentOrderItems(orderNumber) {
        return this.request(HttpMethod.Get, `/api/v3/kol/orders/items`, { order_number: orderNumber });
    }

    // Product Sends
    ProductSendList(params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/product-sends`, params);
    }
    ProductSendDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/product-sends/${id}`);
    }
    ProductSendCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/kol/product-sends`, params);
    }
    ProductSendUpdate(id, params) {
        return this.request(HttpMethod.Put, `/api/v3/kol/product-sends/${id}`, params);
    }
    ProductSendDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v3/kol/product-sends/${id}`);
    }

    // Reports
    ReportByStaff(params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/reports/by-staff`, params);
    }

    // Payout Batches (statements)
    PayoutBatchList(params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches`, params);
    }
    PayoutBatchDetail(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches/${id}`);
    }
    PayoutBatchCreate(params) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches`, params);
    }
    PayoutBatchSubmit(id) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/${id}/submit`, {});
    }
    // Pay requires multipart: file=slip, payment_date=YYYY-MM-DD, payment_note (optional).
    PayoutBatchPay(id, file, paymentDate, paymentNote) {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("payment_date", paymentDate);
        if (paymentNote) fd.append("payment_note", paymentNote);
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/${id}/pay`, fd);
    }
    PayoutBatchSlipURL(id) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches/${id}/slip`);
    }
    PayoutBatchCancel(id) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/${id}/cancel`, {});
    }
    PayoutBatchGet(id, params) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches/${id}`, params);
    }
    PayoutBatchCreateFromFilter(filter) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/from-filter`, filter);
    }
    PayoutBatchItemPay(batchId, itemId, formData) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/pay`, formData);
    }
    PayoutBatchItemUnpay(batchId, itemId, body) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/unpay`, body);
    }
    PayoutBatchItemSlipURL(batchId, itemId) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/slip`);
    }
    PayoutBatchItemDocList(batchId, itemId) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/documents`);
    }
    PayoutBatchItemDocUpload(batchId, itemId, formData) {
        return this.request(HttpMethod.Post, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/documents`, formData);
    }
    PayoutBatchItemDocURL(batchId, itemId, docId) {
        return this.request(HttpMethod.Get, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/documents/${docId}`);
    }
    PayoutBatchItemDocDelete(batchId, itemId, docId) {
        return this.request(HttpMethod.Delete, `/api/v3/kol/payout-batches/${batchId}/items/${itemId}/documents/${docId}`);
    }
}

export default KOLProvider;
